import httpClient from "./httpClient";

const END_POINT = "/api/uploads";
const getAllUploads = () => httpClient.get(END_POINT);
const synchronizeUpload = (upload) => httpClient.post(END_POINT + '/synchronize', upload);

export { getAllUploads, synchronizeUpload };
